import React from 'react';
import { withTheme } from 'styled-components';
import { Svg, Path } from 'react-native-svg';

const Plus = ({ className = '', size = '24px', theme, color = theme.colors['Level 3'] }) => (
    <Svg
        className={className}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <Path
            d="M13 6C13 5.44772 12.5523 5 12 5C11.4477 5 11 5.44772 11 6L11 11H6C5.44772 11 5 11.4477 5 12C5 12.5523 5.44772 13 6 13H11V18C11 18.5523 11.4477 19 12 19C12.5523 19 13 18.5523 13 18V13H18C18.5523 13 19 12.5523 19 12C19 11.4477 18.5523 11 18 11H13V6Z"
            fill={color}
        />
    </Svg>
);

export default withTheme(Plus);
